export default "__VITE_ASSET__Lr55nJ_E__"